/** @graphql cc **/

import gql from 'graphql-tag';

export const UpdateOwnerMutation = gql`
	mutation UpdateOwnerMutation($contentId: ID!, $ownerId: String!) {
		updateOwner(input: { contentId: $contentId, ownerId: $ownerId }) {
			content {
				id
				history {
					ownedBy {
						displayName
						type
						... on KnownUser {
							accountId
						}
						profilePicture {
							path
						}
					}
					lastOwnedBy {
						displayName
						type
						... on KnownUser {
							accountId
						}
						profilePicture {
							path
						}
					}
				}
			}
		}
	}
`;
